import { optionsProps, PaginationType } from '../../../types';
import { create } from 'zustand';

interface Sort {
  headerType: string;
  sortType: string;
}

interface SocketLoaders {
  join: boolean;
  getNotifications: boolean;
  chatLoader: boolean;
}

interface useSocketMessageStore {
  socketData: any;
  socketConnected: boolean;
  /** Bumped on every successful `join` round-trip, including reconnects, so effects can retry work that a drop left unfinished. */
  socketConnectionCount: number;
  socketLoaders: SocketLoaders;
  socket: {};
  connectionList: any[];
  receiverDetail: any | null;
  messageList: {};
  chatId: string;
  imageUploadLoader: boolean;
  getNotificationCount: number;
  notificationResponse: any | null;
  isRecording: boolean;
  imageMessageData: {};
  replyBackMessage: any | null;
  pagination: PaginationType;
  setPagination(pagination: PaginationType): void;
  setState(nextState: Partial<useSocketMessageStore>): void;
}
export const initinalSokectValues = {
  socketData: {},
  socketConnected: false,
  socketConnectionCount: 0,
  socketLoaders: {
    join: false,
    getNotifications: false,
    chatLoader: false,
  },
  socket: {},
  connectionList: [],
  receiverDetail: null,
  messageList: {},
  chatId: '',
  imageUploadLoader: false,
  getNotificationCount: 0,
  notificationResponse: null,
  isRecording: false,
  imageMessageData: {},
  replyBackMessage: null,
  pagination: {
    limit: 50,
    page: 1,
    total: 0,
    pages: 0,
  },
};

const useSocketStore = create<any>((set: any, get: any) => ({
  ...initinalSokectValues,
  getState: () => get(),
  setPagination: (pagination: PaginationType) => set(() => ({ pagination })),
  setState: (nextState: any) => set(() => ({ ...nextState })),
}));

export default useSocketStore;
